import React, { FunctionComponent } from 'react';
import { BarChart, Block, Heading, PendingContent, Spinner } from 'plume-ui';
import { ChartPeriodContext } from '../../../contexts/ChartPeriodContext';
import FormattedMessage from '../../../../../utils/components/FormattedMessage';
import { TimeLinePeriodTypes } from '../../../types';
import MonthDropdown from '../../MonthDropdown/MonthDropdown';
import TimeLinePicker from '../../TimelinePicker/TimelinePicker';
import { useTranslation } from 'react-i18next';
import { useTimeLine } from '../../../hooks/useTimeLine';
import { BarChartDataItem } from '../../../BarChart.fixture';
import { BlockStyles } from 'plume-ui/dist/components/Block/Block';
import { useRecoilValue } from 'recoil';
import { selectedCompanySelector } from '../../../../../state';
import { useFetchData } from '../../../../../hooks/useFetchData';
import { DependencyContainer } from '../../../../../DependencyContainer';

const addStylesToBlock = (current: BlockStyles) => ({
  ...current,
  root: `${current.root} IpsecTunnel`,
});
const { statusService } = new DependencyContainer();
const IpSecTunnelChartContainer: FunctionComponent = () => {
  const { t } = useTranslation();
  const {
    getContextDefaultValues,
    selectedPeriodType,
    selectedMonth,
    getPeriod,
    getType,
  } = useTimeLine();
  const tunnelStatusGroups = [
    {
      label: t('ipsecTunnelChart.primary'),
      color: '#333CFF',
      stroke: '#333CFF',
      key: 'groupC',
    },
    {
      label: t('ipsecTunnelChart.secondary'),
      color: '#00BEDB',
      stroke: '#00BEDB',
      key: 'groupB',
    },
    {
      label: t('ipsecTunnelChart.bothDown'),
      color: '#FC5FA3',
      stroke: '#FC5FA3',
      key: 'groupA',
    },
  ];
  const selectedCompany = useRecoilValue(selectedCompanySelector);
  const [loading, data, error] = useFetchData<BarChartDataItem[], any>(
    async () => {
      if (!selectedCompany) {
        return;
      }
      const [period, type] = [getPeriod(), getType()];
      return await statusService.getIpsec(selectedCompany.id, period, type);
    },
    undefined,
    [selectedCompany, selectedPeriodType, selectedMonth],
    () => selectedCompany === undefined,
  );

  return (
    <ChartPeriodContext.Provider value={getContextDefaultValues()}>
      <PendingContent
        loading={loading}
        isError={Boolean(error)}
        hideContent
        loader={Spinner}
      >
        <Block classes={addStylesToBlock} id="IpsecTunnelChart">
          <Heading level={3} size="xl" medium>
            <FormattedMessage id="ipsecTunnelChart.title" />
          </Heading>
          <div className="IpsecTunnel__timeline--container">
            <span className="IpsecTunnel__timeline--month">
              {selectedPeriodType === TimeLinePeriodTypes.CalendarMonth && (
                <MonthDropdown />
              )}
            </span>
            <TimeLinePicker />
          </div>
          {!data?.length ? (
            <div className="EmployeeOnboarding__empty--container">
              <FormattedMessage id="noDataAvailable" />
            </div>
          ) : (
            <BarChart
              stacked
              data={data}
              groups={tunnelStatusGroups}
              config={{
                showPercentageOnTooltip: true,
                yAxisFormat:
                  selectedPeriodType === TimeLinePeriodTypes.Last24Hours
                    ? '60min'
                    : '24hr',
              }}
              legendPosition="bottom"
            />
          )}
        </Block>
      </PendingContent>
    </ChartPeriodContext.Provider>
  );
};
export default IpSecTunnelChartContainer;
